import ActionLogger from "action-logger";
import PageViewActions from "actions/logging/page-view";
import ActionTypes from "../../../../actions/action-types.js";

export const display_membership_pdp_form = productId => {
  ActionLogger.logAction({
    object_type: "membership_pdp",
    action: "display_membership_pdp_form",
    style_name: productId,
  });
};

export const pdp_size_selection = (selectedSize, productId, isDrawer) => {
  let logObjectType = "membership_pdp";
  let logActionType = "pdp_size_selection";

  if (isDrawer) {
    logObjectType = "membership_drawer";
    logActionType = "drawer_size_selection";
  }

  ActionLogger.logAction({
    object_type: logObjectType,
    action: logActionType,
    style_name: productId,
    size: selectedSize,
  });
};

export const pdp_page_view = dispatch => {
  dispatch(PageViewActions.log(ActionTypes.PDP_PAGE_VIEW));
  dispatch(PageViewActions.pdpPageView());
};

export const zip_code_entry = zipCode => {
  ActionLogger.logAction({
    action: "enter_zipcode",
    object_type: "node",
    zip: zipCode,
  });
};

export const reserve_primary_size = (productId, size) => {
  ActionLogger.logAction({
    action: "selectdd_primarysize",
    object_type: "node",
    style_name: productId,
    pageType: "PDP",
    psize: size,
  });
};

export const reserve_backup_size = (productId, size) => {
  ActionLogger.logAction({
    action: "selectdd_backupsize",
    object_type: "node",
    style_name: productId,
    pageType: "PDP",
    psize: size,
  });
};

export const rezo_select = (date, zip_code) => {
  ActionLogger.logAction({
    object_type: "pdp",
    action: "rezo_select",
    rentBegin: date,
    zip: zip_code ?? "",
  });
};
